import React from "react";
import './Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { FaBars } from "react-icons/fa";
import { useEffect, useRef } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import { LiaLinkedin } from "react-icons/lia";

function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        let [key, value] = cookie.split("=");
        if (key === name) return decodeURIComponent(value);
    }
    return null;
}


const Navbar = (props) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const menuButtonRef = useRef(null); // Ref for the menu button to detect clicks outside
    const [isBoxVisible, setIsBoxVisible] = useState(false);
    const boxRef = useRef(null); // Ref for the hidden box

    const [token, setToken] = useState(getCookie("accessToken"))

    // Close the box when clicking outside


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                boxRef.current &&
                !boxRef.current.contains(event.target) &&
                menuButtonRef.current &&
                !menuButtonRef.current.contains(event.target)
            ) {
                setIsBoxVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleBox = () => {
        setIsBoxVisible(!isBoxVisible);
    };
    const GrayUserIcon = () => (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          strokeWidth="1.4"
          xmlns="http://www.w3.org/2000/svg"
          className="block"
        >
          <circle cx="18" cy="18" r="18" fill="#E0E0E0" />
          <ellipse cx="18" cy="15" rx="7" ry="7" fill="#BDBDBD" />
          <ellipse cx="18" cy="27" rx="10" ry="6" fill="#BDBDBD" />
        </svg>
      );
    


    const filterRef = useRef(null);

    // Toggle filter visibility
    const toggleFilter = () => {
        setIsFilterVisible(!isFilterVisible);
    };

    // Hide filter if clicked outside
    const handleClickOutside = (event) => {
        if (filterRef.current && !filterRef.current.contains(event.target)) {
            setIsFilterVisible(false);
        }
    };

    useEffect(() => {
        // Adding event listener for clicks outside the filter section
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    // const arrayCategory = Cards_Data.map(item => item.category);
    // const disCategory = [...new Set(arrayCategory)];
    const disCategory = ["PEAK", "Pulse", "ConnExa"];
    // console.log(disCategory)

    const closeSidebar = () => {
        setIsFilterVisible(false);
        setOpenCategory(null)
    };



    const [openCategory, setOpenCategory] = useState(null);

    // Function to toggle the dropdown
    const toggleDropdown = (category) => {
        setOpenCategory(openCategory === category ? null : category);
    };


    const location = useLocation(); // Gets current path (e.g., "/x/y")
    const basePath = location.pathname.split("/")[1];

    return (
        <div>
            <nav className="navbar flex justify-between items-center shadow-md  ">
                <div className="flex-grow flex justify-left ">
                    <Link to={`/${basePath}/home`}>
                    <img
          src={props.user.organization.logo}
          alt="Left Logo"
          className="max-w-40 max-h-10 lg:max-w-44 lg:max-h-10 object-contain cursor-pointer mt-0.5 pt-1"
        />
                    </Link>

                </div>


                {/* Right Div */}
                <div className="relative flex-shrink-0 text-right text-xs sm:text-sm md:text-base z-50 w-32 sm:w-40 md:w-44 lg:w-56">
                  <button
                    className="bg-white py-0.5 px-1.5 flex ml-auto items-center user"
                    ref={menuButtonRef}
                    onClick={toggleBox}
                  >
                    {/* Circular gray user icon */}
                    <span className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center mr-2">
                    <GrayUserIcon />
                    </span>
                    <span className="block font-semibold text-sm cursor-pointer text-gray-500 pr-1 hover:text-gray-700">
                      {props.user.firstName} {props.user.lastName}
                    </span>
                    {!isBoxVisible ? (
                      <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="4 8 12 16 20 8"></polyline>
                    </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="8 4 16 12 8 20"></polyline>
                      </svg>
                      
                    )}
                  </button>
                
                  {/* Hidden Box */}
                  {/* {isBoxVisible && (
                    <div
                      ref={boxRef}
                      className="absolute -right-3 mt-2 bg-white shadow-md rounded-lg w-40 md:w-44 hover:bg-gray-100 p-2"
                      id="signoutbox"
                    >
                      {token && (
                        <Link
                          className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:text-gray-700 hover:underline hover:decoration-gray-500"
                          to="../admin"
                        >
                          <img src="/images/Admin.png" className="w-5 h-5" />
                          <span className="ml-1">Administration</span>
                        </Link>
                      )}
                
                      <button
                        onClick={() => { sessionStorage.removeItem('accessToken'); props.logout(); }}
                        className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:underline hover:decoration-gray-500"
                      >
                        <img src="/images/SignOut.png" className="w-5 h-4" />
                        <span className="ml-1">Sign Out</span>
                      </button>
                    </div>
                  )} */}
                </div>
            </nav>

            {/* sub Navbar */}
            <div className="subnav2 md:absolute z-50   px-4 my-1 mb-2 py-1 md:rounded-lg">
                {/* Desktop View */}
                <div className="flex  items-center justify-end xl:justify-between py-1">

                    <nav class="hidden xl:flex justify-between" aria-label="Breadcrumb">
                        <ol class="inline-flex items-center  sm:mb-0">
                            {/* <li>
                                <div class="flex items-center">
                                    <button className="cursor-pointer darkOrange hover:underline hover:decoration-gray-400 ">
                                        <Link className="hover:decoration-gray-400 darkOrange" to={`/${basePath}/home`}>
                                            <svg class="h-7 w-7 text-orange-500  transform transition-transform duration-300 hover:scale-[1.2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                            </svg>


                                        </Link>
                                    </button>
                                </div>
                            </li> */}

                            {/* <span class="mx-2 font-semibold text-xl text-gray-400">/</span>
                            <li aria-current="page">
                                <div class="flex items-center">

                                    <Nav>
                                        <NavDropdown

                                            id="nav-dropdown-dark-example"
                                            title={props.module.category}
                                            menuVariant="dark"
                                            className="darkOrange hover:text-blue-300"
                                        >
                                            {props.user.modules
                                                .filter(item => {
                                                    return item ? item.id != props.module.id && item.category == props.module.category : false;
                                                })
                                                .map((item) => (
                                                    <Link class=" hover:no-underline " to={`/${basePath}/${item.title.toLowerCase()}`}>
                                                        <div className="px-2 py-0.5 my-0.5 mx-1.5 rounded hover:bg-gray-100 hover:decoration-gray-400 darkOrange">
                                                            {item.title}
                                                        </div>
                                                    </Link>
                                                ))} 

                                        </NavDropdown>
                                    </Nav>

                                </div>
                            </li> */}
                            
                        </ol>
                    </nav>


                    <Link to={`/${basePath}/home`}>
                    <h2 className="absolute top-1.5 darkOrange pb-1 title text-center flex-1 text-xl sm:text-2xl md:text-3xl font-bold left-1/2 -translate-x-1/2 hover:underline">
                        {props.module.title}
                    </h2>
                    </Link>


                    {/* Right Side: Search and Buttons */}
                    <div className="flex items-right md:items-center  space-x-4">

                        <button
                            onClick={toggleFilter}
                            className="md:px-4 py-2 text-xl text-orange-500 focus:border-0 btnn transform transition-transform duration-300 hover:scale-[1.2] rounded-md "
                        >
                            <FaBars />
                        </button>
                    </div>
                </div>

            </div>

            {/* Filters Section (Full Height Below Navbar) */}
            {isFilterVisible && (<div
                ref={filterRef}
                className={`absolute top-10 mt-2 right-0 w-52 md:w-64 bg-white shadow-lg shadow-gray-500 z-20  rounded-tl-lg h-full  overflow-y-auto max-h-[calc(100vh-3rem)] pb-3`}

            >
                <button
                    className="flex focus:outline-none items-right mr-auto font-light  mb-1  py-2 pt-3 transform transition-transform duration-300 hover:scale-[1.09]" onClick={closeSidebar}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-10 h-8 py-0.5 text-white hover:shadow-lg  bgback rounded-r-full pr-2"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M4 12h14M12 5l7 7-7 7"
                        />
                    </svg>
                </button>

                <div className="px-3 my-0 flex items-center ">
                    <h2 className="text-xl 2xl:text-2xl text-left pr-2 pb-1 darkBlue sidenavbar font-bold  inline align-middle">
                        Categories
                    </h2>

                    <img
                        src="/images/Categories.png"
                        alt="Center Logo"
                        className="h-8 w-8 p-1  rounded-lg cursor-pointer inline align-middle"
                    />
                </div>

                <div className=" px-2 my-2 mx-3 border-2 bg-gray-50 border-gray-200 pt-2 rounded-lg">
                    <ul className=" text-center">
                        <>
                            {disCategory.filter(cat =>
                                props.user.modules.some(item =>
                                    item && item.id !== props.module.id && item.category === cat
                                )
                            ).map((cat) => {
                                return (
                                    <li
                                        key={cat}
                                        className="cursor-pointer text-left text-gray-400 font-medium text-base 2xl:text-lg mb-3"
                                    >
                                        {/* Category name with a toggle for dropdown */}
                                        <div
                                            className="flex items-center justify-between"
                                            onClick={() => toggleDropdown(cat)}
                                        >
                                            <span className="darkOrange">{cat}:</span>
                                            <button className="ml-2 darkBlue xl:text-2xl focus:outline-none focus:ring-0">
                                                {openCategory === cat ? '−' : '+'}
                                            </button>
                                        </div>

                                        {/* Dropdown content */}
                                        {openCategory === cat && (
                                            <ol className="text-left border-l-2 space-y-2 list-disc list-inside mt-1 ml-1">
                                                {props.user.modules.filter(item =>
                                                    item &&
                                                    item.id !== props.module.id &&
                                                    item.category === cat
                                                ).map((item) => (
                                                    <Link
                                                        key={item.id}
                                                        className="cursor-pointer hover:no-underline hover:decoration-gray-500"
                                                        to={`/${basePath}/${item.title.toLowerCase()}`}
                                                        onClick={closeSidebar}
                                                    >
                                                        <li className="font-medium text-gray-500 text-sm 2xl:text-base ml-3 rounded-lg hover:text-orange-500 hover:bg-gray-100 px-2 py-1">
                                                            {item.title}
                                                        </li>
                                                    </Link>
                                                ))}
                                            </ol>
                                        )}
                                    </li>
                                );
                            })}

                        </>
                    </ul>
                </div>
            </div>)}



            {/* logout card */}
            {isBoxVisible && (<div
                className={`absolute right-2 top-10 bg-white shadow-md rounded-lg w-40 md:w-44  hover:bg-gray-100 p-2 z-100
            }`}
                ref={boxRef}
                id="signoutbox"
            >


                {token && <Link
                    className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex jutify- items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:text-gray-700 hover:underline hover:decoration-gray-500 "
                    to="../admin"
                >
                    <img src="/images/Admin.png" className="w-5 h-5" />
                    <span className="ml-1">Administration</span>

                </Link>}

                <button
                    onClick={() => { sessionStorage.removeItem('accessToken'); props.logout() }}
                    className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex jutify- items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:underline hover:decoration-gray-500 "
                >
                    <img src="/images/SignOut.png" className="w-5 h-4" />
                    <span className="ml-1">Sign Out</span>

                </button>
            </div>)}
        </div >
    );
};

export default Navbar;